export default {
  Forside: 'HN.CoreFrontend.Web.Forside',
  AppInvitation: 'HN.CoreFrontend.Web.AppInvitation',
  Feilmeldinger: 'HN.CoreFrontend.Web.Feilmeldinger',
};
